import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { CARD_RECOVERY_ROUTE } from './card-recovery.service';

@Injectable()
export class CardRecoveryInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(error => {
      const code = error?.error?.code;
      if (code === 'CARD_RECOVERY_REQUIRED') {
        if (!window.location.hash.startsWith('#' + CARD_RECOVERY_ROUTE))
          window.location.replace('/#' + CARD_RECOVERY_ROUTE);
      } else if (code === 'STUDENT_ACCOUNT_DISABLED') {
        sessionStorage.removeItem('jwt_token');
        // Keep login form failures on the form; other active sessions return to login.
        if (!request.url.endsWith('/common/auth/login'))
          window.location.replace('/#/boarding/loginUser?cardRecoveryDisabled=1');
      }
      return throwError(() => error);
    }));
  }
}
